import { Component, inject } from '@angular/core';
import { SpeciesPerVehicleCategoryService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SpeciesPerVehicleCategoryCreateDto,
  SpeciesPerVehicleCategoryDto,
  SpeciesPerVehicleCategoryExcelDownloadDto,
  SpeciesPerVehicleCategoryUpdateDto,
} from '../proxy/general/dtos/species-per-vehicle-category';
import { SPECIESPERVEHICLECATEGORY_CONFIG, SPECIESPERVEHICLECATEGORY_FIELDS } from './species-per-vehicle-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-species-per-vehicle-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SpeciesPerVehicleCategoryService, ConfirmationService],
  templateUrl: './species-per-vehicle-category.html',
  styleUrl: './species-per-vehicle-category.scss',
})
export class SpeciesPerVehicleCategory extends BaseCrudComponent<
  SpeciesPerVehicleCategoryDto,
  SpeciesPerVehicleCategoryCreateDto,
  SpeciesPerVehicleCategoryUpdateDto,
  SpeciesPerVehicleCategoryExcelDownloadDto
> {
  service = inject(SpeciesPerVehicleCategoryService);
  config = SPECIESPERVEHICLECATEGORY_CONFIG;
  fields = SPECIESPERVEHICLECATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: SpeciesPerVehicleCategoryDto): SpeciesPerVehicleCategoryUpdateDto {
    return {
      quantity: data.quantity,
      vehicleCategoryId: data.vehicleCategoryId,
      speciesId: data.speciesId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SpeciesPerVehicleCategory';
  }
}
